// Cross-app link + canonical configuration.
// Override via env vars for production/staging.
export const MAIN_SITE_URL =
  process.env.REACT_APP_MAIN_URL ||
  "https://reliancefashionfactorystores.com";
export const SITE_URL =
  process.env.REACT_APP_SITE_URL ||
  "https://location.reliancefashionfactorystores.com";
